import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import {
    registerSvgs,
    svgArrowRightBold,
    SvgIconComponent,
} from "@hermes/aphrodite/svg";

@Component({
    selector: "h-option-selector",
    standalone: true,
    imports: [SvgIconComponent],
    templateUrl: "./option-selector.component.html",
    styleUrl: "./option-selector.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionSelectorComponent {
    @Input() public inputValue?: string;
    @Input() public inputLabel?: string;
    @Input() public isError: boolean = false;

    constructor() {
        registerSvgs([svgArrowRightBold]);
    }
}
